/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
import React, { forwardRef, Ref } from "react";
import { getSvgResourceForSize, getDefaultSize } from "../../utils";
import { Icon, LodestarIconProps } from "../../icon";
import { SvgToolbarRefresh as ToolbarRefreshSmall } from "./small/ToolbarRefresh";
const sizeMap = {
    small: ToolbarRefreshSmall,
};
const defaultSize = getDefaultSize(sizeMap);

export const ToolbarRefreshIcon = forwardRef(
    (
        { size = defaultSize, ...rest }: LodestarIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon
            ref={ref}
            svgComponent={getSvgResourceForSize(sizeMap, size)}
            size={size}
            {...rest}
        />
    )
);
ToolbarRefreshIcon.displayName = "ToolbarRefreshIcon";
